import { render, staticRenderFns } from "./AddSQL.vue?vue&type=template&id=7d112b8b&scoped=true"
import script from "./AddSQL.vue?vue&type=script&lang=js"
export * from "./AddSQL.vue?vue&type=script&lang=js"
import style0 from "./AddSQL.vue?vue&type=style&index=0&id=7d112b8b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d112b8b",
  null
  
)

export default component.exports